import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import { dateConvertToEpoch } from "web/components/utils/dateToEpoch"
import { Helmet } from "react-helmet";
import { myBidsPostV2 } from 'redux/actions/postLoad';

import MyBids from '../MyBids-v2';

const MyOfferPostBids = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const [response, setResponse] = useState(undefined);
    const [pageType, setPageType] = useState();
    const [activePage, setActivePage] = useState();
    const [activeSearch, setActiveSearch] = useState();
    const [expanded, expandedState] = useState();
    const [type, setType] = useState();

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);
    let title = '';

    const token = localStorage.getItem('token');

    let toDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 31);
    toDate.setDate(fromDate.getDate() + 31);
    let requestedFromDate = fromDate.toISOString().substr(0, 10);
    let requestedToDate = toDate.toISOString().substr(0, 10);
    const urlObject = useSelector(
        (state) => state.urlParameters.bidNeeds
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const storedData = useSelector(
        (state) => state.storedData.payload
    );
    let authId = storedData?.authId
    const fetchMyAPI = useCallback(async (pageNumber, sort, pageType, values) => {
        if (token === null) {
            setModalContent('Please Sign In again.');
            setModalLink('/sign-in');
            toggleModal();
        } else {
            let data
            if (values !== undefined) {
                data = {
                    bidStatus: values.bidStatus,
                    shippingMode: values.deliveryReq,
                    authId: authId,
                    locationId: storedData?.locationID,
                    startDate: values.fromDate,//dateConvertToEpoch(values.fromDate),
                    endDate: values.toDate,//dateConvertToEpoch(values.toDate)
                }
            } else {
                data = {
                    bidStatus: 'ALL',
                    shippingMode: 'ALL',
                    authId: authId,
                    locationId: storedData?.locationID,
                    startDate: requestedFromDate,//dateConvertToEpoch(requestedFromDate),
                    endDate: requestedToDate,//dateConvertToEpoch(requestedToDate)
                }
            }

            let response = await dispatch(myBidsPostV2(token, data));

            if (response?.success) {
                if (response?.data) {
                    setResponse(response?.data)
                } else {
                    setResponse(undefined)
                }
            } else {
                if (response.statusCode === 401) {
                    history.push('./sign-in')
                    window.location.reload(false);
                } else {
                    if (response?.data?.error?.message !== "No records found.") {
                        setModalContent(response?.data?.error?.message);
                        setModalLink('');
                        toggleModal();
                    }
                    setResponse()
                }
            }
        }
    }, []);

    useEffect(() => {
        if (urlObject && urlObject.activePage === null) {
            setActivePage("Active")
        } else {
            setActivePage(urlObject && urlObject.activePage)
        }

        if (urlObject) {
            setType(urlObject && urlObject.type)
            setActiveSearch(urlObject && urlObject.activeSearch)
            expandedState(urlObject && urlObject.expanded)
        } else {
            setType('bidsPalletNeeds')
            setActiveSearch('PostLoad')
            expandedState('panel2')
            setActivePage("PostLoad")
            setPageType('PostLoad')
        }

        if (!localStorage.getItem('token')) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            if (urlObject)
                setPageType(urlObject.postType);
            fetchMyAPI(1, 'ASC', urlObject && urlObject.postType);

        }
    }, [fetchMyAPI]);



    return (<>
        <Helmet title="View The Bids You've Placed for Pallet Needs | PalletTrader" >
            <meta name="description"
                content="Review the bids you've made on pallet needs. From the time a bid or offer has been accepted, buyers and sellers have complete shipment visibility." />
            <meta name="robots" content="index,follow" />
            <link rel="canonical" href="https://www.pallettrader.com/view-my-bids-on-pallet-needs" />
        </Helmet>
        <MyBids response={response} pageType={pageType} type={type}
            activeSearch={activeSearch} expanded={expanded} activePage={activePage} callBackFun={(pageNumber, sort, pageType, values) => { fetchMyAPI(pageNumber, sort, pageType, values) }} />

        <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
        />
    </>
    )
};

export default MyOfferPostBids;